import { faCancel, faCheck, faClose, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IImportFileNew } from 'interfaces/price';
import ReferenceSearchOrder from '../../ReferenceSearchOrder/ReferenceSearchOrder';
import { notify } from 'utils/marketplace';
import { de } from 'date-fns/locale';

type Props = {

  index: number;
  item
  setData: (data: IImportFileNew[]) => void;
  rowsData: IImportFileNew[];
  setValidatePressedRows: (rows: string[]) => void;
  setStepModal: (step: string) => void;
  currentPage
  setCurrentPage: (page: number) => void;
  itemsPerPage: number;
  showReplace: boolean;
  validatePressedRows: string[];
  setRemplaceReferenceOrNFP?: (data) => void;

};

const ActionContentElementReplace: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [confirmChangeRef, setConfirmChangeRef] = useState(false);
  const [selectedItem, setSelectedItem] = useState<IImportFileNew>();
  const [resetInputRef, setResetInputRef] = useState(false);

  const handleOkClick = (index, type) => {


    if (props.validatePressedRows.includes(index) && type == 'delete') {
      // Șterge index-ul
      props.setValidatePressedRows(
        props.validatePressedRows.filter((i) => i !== index)
      );
    }

    if (type == 'add') {
      // Adaugă index-ul
      props.setValidatePressedRows([...props.validatePressedRows, index]);
    }
  };

  // Function to remove an item from the data table
  // and update the local storage
  const removeItem = (itemRemoved) => {

    if (props.setRemplaceReferenceOrNFP) {
      props.setRemplaceReferenceOrNFP((prev) => [...prev, {
        reference: itemRemoved.replace?.reference,
        reference_full: itemRemoved.replace?.reference_full,
        reference_new: itemRemoved.reference,
        reference_new_full: itemRemoved.reference_full,
        reason: itemRemoved.reference != '-' ? 'replacement' : 'NFP',
        description: (itemRemoved.reference != '-' ? itemRemoved.description : itemRemoved.replace?.description) || '',
        action_user: 'deleted'
      }]);
    }

    const dataTable = props.rowsData.map((item) => {
      const updatedParts = item.parts.filter((part) => !(part.reference == itemRemoved.reference && part.index == itemRemoved.index && part.codfou == itemRemoved.codfou));

      return { ...item, parts: updatedParts };
    });

    const filteredData = dataTable.filter((item) => Array.isArray(item.parts) && item.parts.length !== 0);

    const updatedPartsWithReplacements = proformaFile.partsWithReplacements.map((item) => {
      const updatedParts = item.parts.filter((part) => !(part.reference == itemRemoved.reference && part.index == itemRemoved.index && part.codfou == itemRemoved.codfou));

      return { ...item, parts: updatedParts };
    });

    localStorage.setItem('proformaFileInProgress', JSON.stringify({
      ...proformaFile,
      count: proformaFile.count - 1,
      partsWithReplacements: updatedPartsWithReplacements.filter((item) => Array.isArray(item.parts) && item.parts.length !== 0)
    }));
    notify(t('_references_deleted'), 'success', t('_success'));
    props.setData(filteredData);

    if (props.currentPage === 1) {
      props.setCurrentPage(props.currentPage);
    }
    else if (props.currentPage > Math.ceil(filteredData.length / props.itemsPerPage)) {
      props.setCurrentPage(Math.ceil(filteredData.length / props.itemsPerPage));
    } else {
      props.setCurrentPage(props.currentPage);
    }

    if (filteredData.length === 0) {
      props.setStepModal('ValidationReferencesNotFound');
    }

  };
  // finish remove item

  const show = (id: string, type, event: React.MouseEvent) => {
    event.stopPropagation();
    document.getElementById(String(id))!.style.display = type;
  };

  const onclickConfirmRef = (status: boolean, showReplaceStatus: boolean) => {


    if (showReplaceStatus) {

      const dataTable = props.rowsData.map((item) => {
        const updatedParts = item.parts.map((part) => {
          if (part.reference === props.item.reference && part.index === props.item.index && part.codfou === props.item.codfou) {
            return { ...part, replaceRef: status, newRef: null };
          }

          return part;
        });

        return { ...item, parts: updatedParts };
      });

      props.setData(dataTable);

    } else {

      if (selectedItem) {

        const data = proformaFile.partsWithReplacements || [];

        const isRefExists = data.some((item) =>
          item.parts.some((part) => part.short_name == selectedItem?.parts[0].reference)
        );

        if (isRefExists) {
          notify(t('_item_already_exists'), 'warning');


        }

        const dataTable = props.rowsData.map((item) => {
          const updatedParts = item.parts.map((part) => {
            if (part.reference === props.item.reference && part.index === props.item.index && part.codfou === props.item.codfou) {
              return { ...part, replaceRef: status, newRef: selectedItem };
            }

            return part;
          });

          return { ...item, parts: updatedParts };
        });

        props.setData(dataTable);

      } else {
        notify(t('_select_reference'), 'error', t('_error'));
        setConfirmChangeRef(false);
      }
    }

    if ((status && showReplaceStatus) || (status && selectedItem)) {
      setConfirmChangeRef(true);
      handleOkClick(props.item.reference + '-' + props.index, 'add');
    } else {
      handleOkClick(props.item.reference + '-' + props.index, 'delete');
      setConfirmChangeRef(false);

      if (!showReplaceStatus) {
        setSelectedItem(undefined);
        setResetInputRef(true);
      }
    }

  };

  return (
    <React.Fragment key={props.index}>
      <ReferenceSearchOrder
        currentPage={props.currentPage}
        item={props.item}
        index={props.item.reference + props.index}
        setSelectedItem={setSelectedItem}
        resetInputRef={resetInputRef}
        setResetInputRef={setResetInputRef}
        showReplace={props.showReplace}
      />
      {confirmChangeRef || props.item.replaceRef
        ? <div className="no-validate" onClick={() => { onclickConfirmRef(false, props.showReplace); }} > <FontAwesomeIcon icon={faCancel} />   {t('_cancel')} </div>
        : <div className="validate" onClick={() => onclickConfirmRef(true, props.showReplace)} > <FontAwesomeIcon icon={faCheck} />   {t('_validate')} </div>
      }

      <div className="remove" onClick={(event) => show('delete' + props.item.reference + props.index, 'block', event)} ><FontAwesomeIcon icon={faTrashCan} />
        <div className="tooltip-order"
          id={String('delete' + props.item.reference + props.index)}
          onMouseLeave={(event) =>
            setTimeout(() => {
              show(String('delete' + props.item.reference + props.index), 'none', event);
            }, 100)
          }
        >
          <div className="tooltip_lable">
            <button className="yes" onClick={() => removeItem(props.item)}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
            <button className="no" onClick={(event) => show('delete' + props.item.reference, 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
          </div>
        </div>
      </div>

    </React.Fragment >
  );
};

ActionContentElementReplace.displayName = 'ActionContentElementReplace';

export default ActionContentElementReplace;
